import { Injectable } from '@angular/core';
import { OrderPortalEntry } from '../models/order-portal';

@Injectable({
  providedIn: 'root'
})
export class OrderPortalChannelService {
  constructor() {}

  getCreatedEntityName(entry: OrderPortalEntry): string {
    if (entry.orderChannel === 'GUNG_WEB_OFFER') {
      return 'OFFER';
    } else if (entry.orderChannel === 'GUNG_WEB_RETURN') {
      return 'RETURN';
    } else if (this.isEdiToGungChannel(entry.orderChannel)) {
      return 'EDI_ORDER_MESSAGE';
    }

    return 'ORDER';
  }

  getOriginalInputRoute(entry: OrderPortalEntry, id: string): string {
    if (entry.orderChannel === this.ediOrderRegistrationChannel) {
      return '/admin/edi/orders/' + id;
    }
    return undefined;
  }

  getCreatedEntityRoute(entry: OrderPortalEntry, id: string): EntityRoute {
    const entityName = this.getCreatedEntityName(entry);
    if (entityName === 'ORDER') {
      return {
        link: '/orders/' + id,
        params: {}
      };
    } else if (entityName === 'OFFER') {
      return {
        link: '/offers/' + id,
        params: {}
      };
    } else if (entityName === 'RETURN') {
      return {
        link: '/return-warranty',
        params: {
          search: 'DEFAULT__:__' + id
        }
      };
    } else if (entityName === 'EDI_ORDER_MESSAGE') {
      return {
        link: '/admin/edi/orders/' + id,
        params: {}
      };
    }

    return undefined;
  }

  // The only EDI channel that actually creates orders in the ERP. All other EDI channels
  // create EDI messages, which in turn are registered as orders through this channel.
  protected readonly ediOrderRegistrationChannel = 'EDI_ORDER_REGISTRATION';

  // This variable contains EDI channels that are incoming messages to GUNG but are not
  // named with an EDI prefix, and therefore cannot be detected automatically.
  protected ediToGungChannels: { [s: string]: boolean } = {
    B24_V2: true
  };

  protected isEdiToGungChannel(orderChannel: string): boolean {
    if (!orderChannel || orderChannel === this.ediOrderRegistrationChannel) {
      return false;
    }
    return orderChannel.startsWith('EDI') || !!this.ediToGungChannels[orderChannel];
  }
}

export interface EntityRoute {
  link: string;
  params: { [key: string]: string };
}
